import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

import { Grid } from '@mui/material';
import Dashboard from 'layouts/V2/Dashboard';
import PropTypes from 'prop-types';

import styles from './guesty.module.css';

import GuestyPage from './GuestyPage';
import ConfigureBrand from './components/ConfigureBrand';
import EditDefaultBrand from './components/EditDefaultBrand';

function GuestyHome(props) {
    return (
        <Grid>
            <Switch>
                <Route
                    path={`${props.match.path}`}
                    render={() => <GuestyPage {...props} />}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid/edit`}
                    render={() => (
                        <Dashboard mainContainerStyles={styles.editBrandWrapper}>
                            <EditDefaultBrand {...props} />{' '}
                        </Dashboard>
                    )}
                    exact
                />
                <Route
                    path={`${props.match.path}/brands/:uuid`}
                    render={() => <ConfigureBrand {...props} />}
                    exact
                />
            </Switch>
        </Grid>
    );
}

GuestyHome.propTypes = {
    match: PropTypes.object,
};

export default withRouter(GuestyHome);
